import { Client } from '../../../shared/api/use-client-subscription';
import { useCreateMedicareQuoteForClientMutation } from '@coverright/data-access/medicare';
import { useEffect, useState } from 'react';
import { MedicareQuoteFilterExtraBenefit } from '@coverright/data-access/types/medicare';
import { mainBackendApolloClient } from '@coverright/data-access/apollo-clients';

export function useCreateMedicareQuoteIfNotExists(client?: Partial<Client>) {
  const [create, {called}] = useCreateMedicareQuoteForClientMutation({
    client: mainBackendApolloClient
  });

  useEffect(() => {
    if (client?.id && !called && !client?.quoteId && client?.zip && client?.countyName) {
      create({
        variables: {
          clientId: client.id,
          data: {
            zip: client.zip,
            county: client.countyName,
            filters: {
              extraBenefits: [MedicareQuoteFilterExtraBenefit.DrugCoverage],
            }
          }
        }
      })
    }
  }, [client, called, create]);
}
